export default __webpack_public_path__ + "static/distance-83fe806b0602fe27be3ed3b9908a21be.png";